/* global axios */
import ApiClient from './ApiClient';

class AiSuggestionsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  index(conversationId) {
    return axios.get(`${this.url}/${conversationId}/ai_suggestions`);
  }

  accept(conversationId, id) {
    return axios.post(`${this.url}/${conversationId}/ai_suggestions/${id}/accept`);
  }

  reject(conversationId, id) {
    return axios.post(`${this.url}/${conversationId}/ai_suggestions/${id}/reject`);
  }

  // «Не актуально»: закрыть подсказку без оценки качества (не rejected).
  dismiss(conversationId, id) {
    return axios.post(`${this.url}/${conversationId}/ai_suggestions/${id}/dismiss`);
  }

  update(conversationId, id, data) {
    return axios.patch(`${this.url}/${conversationId}/ai_suggestions/${id}`, {
      ai_suggestion: data,
    });
  }
}

export default new AiSuggestionsAPI();
